import {
  SingleToolSimilar,
  SingleToolFooter,
  SYMBOLS_TOOL,
  ToolCategory,
} from '@quicktools/shared-components';
import ReviewSnippet from '@quicktools/shared-components/components/landingPages/ReviewSnippet/ReviewSnippet';
import { useTranslation } from 'react-i18next';

import analytics from '../../services/analytics';
import ImageSections from '../Landing/ImageSections';
import { SIMILAR_TOOLS } from '../../configs';

import useStyles from './styles';

export default function SeoContent() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <ReviewSnippet
        ratingValue={4.5}
        ratingCount={111}
        title={t('landing.reviewSnippet.title')}
        subtitle={t('landing.reviewSnippet.subtitle')}
      />

      <ImageSections />

      <SingleToolSimilar
        current={SYMBOLS_TOOL}
        analytics={analytics}
        similar={SIMILAR_TOOLS}
        paragraph={t('landing.similarTools.paragraph')}
        category={ToolCategory.Text}
      />

      <SingleToolFooter analytics={analytics} />
    </div>
  );
}
